import ErrorImage from '../../../assets/images/error.svg'
import Form from '../../../components/form/Form'
import ChipButton from '../../../components/py_modules/ChipButton'
import { useStepsContext } from '../../../context/StepsContext'
import useFormFields from '../../../hooks/useFormFields'

const ChipValidation = () => {
  const { chipValidationError }: any = useStepsContext()
  const { chipValidationFields } = useFormFields()

  const storeForm: string = 'chipValidationForm'

  const validationError = (
    <main className="landing">
      <div className="landing-container">
        <img src={ErrorImage} alt="validation error" style={{ height: '160px' }} />
        <h3>
          <strong>Algo salió mal en la activación de este chip</strong>
        </h3>
        <p className="error-sugest">
          Por favor intentá con otro. <br />
          Si el problema persiste reportá el caso enviando un sms al 7767 desde cualquier línea Claro
          <br />o al 0994 401 111
        </p>
        <ChipButton label="Volver a probar" storeForm={storeForm} error />
      </div>
    </main>
  )

  const validationForm = (
    <main className="form">
      <div className="form-container">
        <h2 className="form-title">Completá los datos para validar el chip</h2>
        <Form fields={chipValidationFields} storeForm={storeForm} inputsPosition="floating" />
        <ChipButton label="Continuar" storeForm={storeForm} />
      </div>
    </main>
  )
  return (
    <>
      {!chipValidationError && validationForm}
      {chipValidationError && validationError}
    </>
  )
}

export default ChipValidation
